import _ from 'lodash'
import { fromJS } from 'immutable'
import { getGridAreaForMode } from '../hooks/useValueForDevice'
import { LAYOUT_MODE } from './toUnits'
import { num2chars } from './CardComponent'

export const getGridData = (style, layoutMode) => {
  const lgColsValue = style.getIn(['lg', 'columns'], 3)
  const mdColsValue = style.getIn(['md', 'columns'], null)
  const smlColsValue = style.getIn(['sml', 'columns'], null)
  const smColsValue = style.getIn(['sm', 'columns'], 1)
  const smColsValueNull = style.getIn(['sm', 'columns'], null)
  const xsColsValue = style.getIn(['xs', 'columns'], 1)
  const xsColsValueNull = style.getIn(['xs', 'columns'], null)
  const ssColsValue = style.getIn(['ss', 'columns'], 1)
  const ssColsValueNull = style.getIn(['ss', 'columns'], null)

  let prevColsValue = lgColsValue
  {
    let values = [
      lgColsValue,
      mdColsValue,
      smlColsValue,
      smColsValue,
      smColsValueNull,
      xsColsValueNull,
      ssColsValueNull,
    ]
    let valueIndex = LAYOUT_MODE.indexOf(layoutMode)
    if (valueIndex !== -1) {
      let value = values[valueIndex]
      do {
        if (LAYOUT_MODE[valueIndex] == 'xs' && layoutMode == 'ss') {
          value = values[--valueIndex]
        }
        if (typeof value !== 'undefined' && value !== null) {
          prevColsValue = value
          break
        }
        value = values[--valueIndex]
      } while (valueIndex >= 0)
    }
  }

  let columns = lgColsValue
  {
    const values = [lgColsValue, mdColsValue, smlColsValue, smColsValue, xsColsValue, ssColsValue]
    let valueIndex = LAYOUT_MODE.indexOf(layoutMode)
    if (valueIndex !== -1) {
      let value = values[valueIndex]
      do {
        if (typeof value !== 'undefined' && value !== null) {
          columns = value
          break
        }
        value = values[--valueIndex]
        if (LAYOUT_MODE[valueIndex] == 'xs' && layoutMode == 'ss') {
          value = values[--valueIndex]
        }
      } while (valueIndex >= 0)
    }
  }

  const lgRowsValue = style.getIn(['lg', 'rows'], 3)
  const mdRowsValue = style.getIn(['md', 'rows'], null)
  const smlRowsValue = style.getIn(['sml', 'rows'], null)
  const smRowsValue = style.getIn(['sm', 'rows'], null)
  const xsRowsValue = style.getIn(['xs', 'rows'], null)
  const ssRowsValue = style.getIn(['ss', 'rows'], null)

  let rows = lgRowsValue
  {
    const values = [lgRowsValue, mdRowsValue, smlRowsValue, smRowsValue, xsRowsValue, ssRowsValue]
    let valueIndex = LAYOUT_MODE.indexOf(layoutMode)
    if (valueIndex !== -1) {
      let value = values[valueIndex]
      do {
        if (typeof value !== 'undefined' && value !== null) {
          rows = value
          break
        }
        value = values[--valueIndex]
        if (LAYOUT_MODE[valueIndex] == 'xs' && layoutMode == 'ss') {
          value = values[--valueIndex]
        }
      } while (valueIndex >= 0)
    }
  }

  if (layoutMode === 'xs' && xsRowsValue === null) {
    if (prevColsValue !== columns) {
      rows = rows * prevColsValue
    }
  } else if (layoutMode === 'ss' && ssRowsValue === null) {
    if (prevColsValue !== columns) {
      rows = rows * prevColsValue
    }
  } else if (layoutMode === 'sm' && smRowsValue === null) {
    if (prevColsValue !== columns) {
      rows = rows * prevColsValue
    }
  }
  const lgValue = style.getIn(
    ['lg', 'areas'],
    fromJS(_.chunk(_.times(columns * rows, (n) => num2chars(n, false), columns)))
  )
  const mdValue = style.getIn(['md', 'areas'], null)
  const smlValue = style.getIn(['sml', 'areas'], null)
  const smValue = style.getIn(['sm', 'areas'], null)
  const xsValue = style.getIn(['xs', 'areas'], null)
  const ssValue = style.getIn(['ss', 'areas'], null)

  let areas = getGridAreaForMode(columns, rows, lgValue, mdValue, smValue, xsValue, ssValue, layoutMode, smlValue)

  return {
    rows,
    columns,
    areas,
  }
}
